import React, { createContext, useState, useEffect } from 'react';
import axios from 'axios';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [token, setToken] = useState(localStorage.getItem('token'));

  useEffect(() => {
    if (token) {
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      fetchUser();
    } else {
      setLoading(false);
    }
  }, [token]);

  const fetchUser = async () => {
    try {
      const API_URL = process.env.REACT_APP_API_URL || '';
      const url = `${API_URL}/api/auth/me`;
      console.log('🔍 fetchUser - URL:', url);
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${token}` }
      });
      console.log('✅ fetchUser - Réponse:', res.data);
      setUser(res.data.user);
    } catch (error) {
      console.error('❌ fetchUser - Erreur:', error);
      localStorage.removeItem('token');
      setToken(null);
      delete axios.defaults.headers.common['Authorization'];
    } finally {
      setLoading(false);
    }
  };

  const login = async (email, password) => {
    try {
      const API_URL = process.env.REACT_APP_API_URL || '';
      const url = `${API_URL}/api/auth/login`;
      console.log('🔍 login - URL:', url);
      const res = await axios.post(url, { email, password });
      console.log('✅ login - Réponse:', res.data);
      const { token: newToken, user: newUser } = res.data;
      localStorage.setItem('token', newToken);
      setToken(newToken);
      setUser(newUser);
      axios.defaults.headers.common['Authorization'] = `Bearer ${newToken}`;
      return { success: true };
    } catch (error) {
      console.error('❌ login - Erreur:', error);
      console.error('📋 Détails:', {
        message: error.message,
        response: error.response?.data,
        status: error.response?.status,
        url: error.config?.url
      });
      return {
        success: false,
        message: error.response?.data?.message || 'Erreur de connexion. Vérifiez que le serveur backend est démarré.'
      };
    }
  };

  const logout = () => {
    localStorage.removeItem('token');
    setToken(null);
    setUser(null);
    delete axios.defaults.headers.common['Authorization'];
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, isAuthenticated: !!user }}>
      {children}
    </AuthContext.Provider>
  );
};

